import { TabProps } from '@/components/molecules/tab/tab';
import { ContentSearchResult } from '@/components/organisms/content-search-card/content-search-card';

type ContentSearchTags = ContentSearch.Properties.ContentSearchTag[];

interface UniqueTags {
  amount: number;
  tag: string;
}

/**
 * Returns the number of items grouped by tag
 */
export const getUniqueTags = (items: ContentSearchResult[]): UniqueTags[] => {
  return (
    [...new Set(items.map(i => i.tag))]?.map(tag => ({
      amount: items.filter(i => i.tag === tag)?.length,
      tag: tag ? tag : '',
    })) || []
  );
};

/**
 * Returns the value map to display
 */
export const getTagNameMap = (
  data: ContentSearchTags,
  valueType: 'tabValue' | 'resultValue',
): Record<string, string> => {
  const result: Record<string, string> = {};

  data.forEach(item => {
    const value = item[valueType];

    if (!value) return;

    result[item.pageType] = value;
  });

  return result;
};

/**
 * Returns the tabs
 */
export const getTabs = (
  items: ContentSearchResult[],
  contentSearchTags: ContentSearchTags,
  onClick: (tag: string) => void,
  t: (key: string) => string,
): TabProps[] => {
  const tagNameMap = getTagNameMap(contentSearchTags, 'tabValue');

  const allTab = {
    count: items.length,
    id: '',
    onClick: () => onClick(''),
    text: t('items.common.words.all'),
  };

  const tabs = getUniqueTags(items).map(item => ({
    count: item.amount,
    id: item.tag,
    onClick: () => onClick(item.tag),
    text: tagNameMap[item.tag] || item.tag,
  }));

  return [allTab, ...tabs];
};
